import { Menu } from "antd";
import { BsChat } from "react-icons/bs";
import { BiUserCircle } from "react-icons/bi";
import { useEffect, useRef, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container } from "./styles";
import { useAuth } from "../../contexts/AuthContext";
import { useBroker } from "../../contexts/BrokerContext";
import { useB3Integration } from "../../contexts/B3IntegrationContext";
import { ReactComponent as BolsaIcon } from "../../assets/calculadoras/bolsa-de-valores.svg";
import { ReactComponent as CryptoIcon } from "../../assets/calculadoras/criptomoedas.svg";
import { ReactComponent as ExteriorIcon } from "../../assets/calculadoras/ativos-no-exterior.svg";

export const TabNavigator = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { currentBroker, xtageIntegration, integration } = useBroker();
  const { b3Authorized } = useB3Integration();
  const {
    user,
    chatOpen,
    setChatOpen,
    chatNotificationQtt,
    forceUpdateTabNavigator,
  } = useAuth();

  const [activeKey, setActiveKey] = useState<string>("");
  
  const handleNavigate = (path: string) => {
    // URLs externas - abre em nova aba
    if (path.includes("http")) {
      window.open(path, "_blank")?.focus();
      return;
    }

    // Usuário não logado - redireciona para páginas de integração
    if (!user.user) {
      const extension: Record<string, string> = {
        bolsa: "-integration",
        exterior: "-integration",
      };
      const pathSegment = path.split("/")[2];
      const suffix = extension[pathSegment] || "";
      navigate(`${path}${suffix}`);
      return;
    }

    // Usuário logado - navegação condicional baseada em integrações
    const brokerPath = `/${currentBroker.path}`;

    // Página de bolsa - verifica autorização B3
    if (path === `${brokerPath}/bolsa`) {
      const targetPath = b3Authorized ? path : `${brokerPath}/bolsa-integration`;
      navigate(targetPath);
      return;
    }

    // Página de exterior - verifica integração
    if (path === `${brokerPath}/exterior`) {
      const targetPath = !integration.integrated && !user.user.isIntegratedExterior
        ? `${brokerPath}/exterior-integrations?redirect=true`
        : path;
      navigate(targetPath);
      return;
    }

    // Página de cripto - verifica integração xtage
    if (path === `${brokerPath}/cripto`) {
      const targetPath = !xtageIntegration ? `${brokerPath}/cripto-integration` : path;
      navigate(targetPath);
      return;
    }

    // Outras páginas - navegação direta
    navigate(path);
  };

  useEffect(() => {
    const path = pathname.substring(1, 40);
    setActiveKey(path);
  }, [navigate])

  const menuItems = useMemo(
    () => [
      {
        key: "carteira",
        label: "Carteira",
        icon: <BiUserCircle />,
      },
      {
        key: "velotax/bolsa",
        label: "Bolsa",
        icon: <BolsaIcon />,
      },
      {
        key: "velotax/exterior",
        label: "Exterior",
        icon: <ExteriorIcon />,
      },
      // {
      //   key: "velotax/cripto",
      //   label: "Cripto",
      //   icon: <CryptoIcon />,
      // },
      {
        key: "chat",
        label: "Chat",
        icon: <BsChat />,
      },
    ],
    [chatNotificationQtt]
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const element = document.getElementById('chatbase-bubble-window');
      setChatOpen(element?.style.display == 'flex');
    }, 500)
    return () => {
      clearInterval(interval);
    }
  }, [])

  useEffect(() => {
    if (!chatOpen)
    {
      const matchItem = menuItems
        .filter((item) => item.key !== "/")
        .find(
          (item) =>
            (item.key.includes("exterior") &&
              pathname.includes("transferencia-custodia")) ||
            pathname.includes(item.key)
        );
      setActiveKey(matchItem?.key || "carteira");
    }
  }, [chatOpen])

  return (
    <Container>
      <Menu
        mode="horizontal"
        disabledOverflow
        activeKey={activeKey}
        selectedKeys={[activeKey]}
        style={{ justifyContent: "space-between" }}
        onClick={(e) => {
          const element = document.getElementById('chatbase-bubble-window');
          if (element && element !== null) element.style.display = 'none';
          setActiveKey(e.key);
          if (e.key === "chat") {
            document.getElementById("chat-gpt-button")?.click();
          } else {
            const fullPath = e.key.startsWith('/') ? e.key : `/${e.key}`;
            handleNavigate(fullPath);
          }
        }}
      >
        {menuItems.map((item) => (
          <Menu.Item key={item.key} icon={item.icon}>
            {item.label}
          </Menu.Item>
        ))}
      </Menu>
      <span className="hidden">{forceUpdateTabNavigator}</span>
    </Container>
  );
};
